function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var DiscountFilled = function DiscountFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M13.974 1.443a2.54 2.54 0 0 0-3.949 0 2.54 2.54 0 0 1-2.633.855A2.54 2.54 0 0 0 4.197 4.62a2.54 2.54 0 0 1-1.628 2.24 2.54 2.54 0 0 0-1.22 3.756 2.54 2.54 0 0 1 0 2.77 2.54 2.54 0 0 0 1.22 3.755 2.54 2.54 0 0 1 1.628 2.24 2.54 2.54 0 0 0 3.195 2.322c.97-.261 2.002.074 2.633.855a2.54 2.54 0 0 0 3.95 0 2.54 2.54 0 0 1 2.633-.855 2.54 2.54 0 0 0 3.195-2.321 2.54 2.54 0 0 1 1.627-2.24 2.54 2.54 0 0 0 1.22-3.756 2.54 2.54 0 0 1 0-2.77 2.54 2.54 0 0 0-1.22-3.755 2.54 2.54 0 0 1-1.627-2.24 2.54 2.54 0 0 0-3.195-2.322 2.54 2.54 0 0 1-2.634-.855m-5.686 15.14a.75.75 0 0 1-.11-1.055l6.481-8.005a.75.75 0 1 1 1.166.944l-6.482 8.005a.75.75 0 0 1-1.055.11m-1.192-7.05a1.502 1.502 0 0 0 2.808-1.07c-.29-.77-1.169-1.156-1.94-.867-.772.289-1.157 1.167-.868 1.937m7 6a1.502 1.502 0 0 0 2.808-1.07c-.29-.77-1.169-1.156-1.94-.867-.772.289-1.157 1.167-.868 1.937",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
export default DiscountFilled;
DiscountFilled.displayName = 'DiscountFilled';